import { Button } from "components/Button/Button";
import { FileInput } from "components/FileInput/FileInput";
import { useEffect, useState } from "react";
import { importProcessMakerFiles } from "./Users/api";

interface props {
    showForm?: () => any
    reload?: () => any
   
}
export const ImportProcessesForm = ({showForm,reload }:props) => {

    const [resetForm, setResetForm] = useState(false);
    const [selectedFile, setSelectedFile] = useState<any>();

    const handleSelectedFile = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            // setSelectedFile(e.target.files[0]);
            setSelectedFile({url: URL.createObjectURL([...e.target.files][0] )   ,file:[...e.target.files][0]}); 

        }
    };
    async function sendDataToServer(event) {
        event.preventDefault();
        try {
            var data = new FormData();
            data.append("file", selectedFile?.file);
            const res = await importProcessMakerFiles(data)
            reload&&reload()
        } catch (error) {
            
        }
       
    }

    useEffect(() => {
        if (resetForm) {
            setResetForm(false);
        }
    }, [resetForm]);

    return (<>
        <div className="col-lg-12 mb-1">
            <div className="card ">
                <div className="card-body">
                    <form
                        className="row d-flex flex-row"
                        onSubmit={sendDataToServer}
                    >
                        <div className="col-lg-4 mt-3">
                            <FileInput
                                maxSize={25600000}
                                lable="ProcessMakerFile"
                                name="ProcessMakerFile"
                                onChange={handleSelectedFile}
                                hideSrc={true} />
                        </div>
                        <div className="col-lg-12 mt-1 btns_form">
                            <Button value="confirm" btnType="submit" />
                            <Button
                                btnType="cancel"
                                value="Cancel"
                                onClick={() => { setResetForm(true);showForm&& showForm() }}
                            />
                        </div>
                    </form >
                </div>
            </div>
        </div>
    </>)
}